<template>
	<SignUpPageBase :content="this">
		<h4 class="font_lg font_bold margin_title_bottom">{{ $t("signUp.password.title") }}</h4>
		<form class="flex flex_center flex_column w_100">
			<div class="text_left light_bg_color margin_vertical w_100">
				<span class="font_bold">{{ $t("common.hint.password.title") }}</span>
				<br/>
				<ul class="tip_list">
					<li v-for="n in 3" :key="n">
						<i class="fa fa-minus font_sm" aria-hidden="true"></i>
						{{ $t(`common.hint.password.text${n}`) }}
					</li>
				</ul>
			</div>
			<md-field>
				<label>{{ $t("common.email") }}</label>
				<md-input
					:value="form.userEmail"
					autocomplete="username"
					disabled
					required
				></md-input>
			</md-field>
			<md-field :class="[{ 'md-error': errors.has('userPassword') }]">
				<md-input
					v-model="form.userPassword"
					v-validate.immediate="modelValidations.userPassword"
					data-vv-name="userPassword"
					type="password"
					autocomplete="new-password"
					required
					ref="userPassword"
				></md-input>
				<label>{{ $t("common.password") }}</label> <!-- Must be after input for autofill fix -->
			</md-field>
			<div class="strength">
				<span v-if="strength >= 0 && form.userPassword.length"></span>
				<span v-if="strength >= 3"></span>
				<span v-if="strength >= 4"></span>
			</div>
			<md-field :class="[{ 'md-error': errors.has('userPasswordRepeat') }]">
				<md-input
					v-model="form.userPasswordRepeat"
					v-validate="modelValidations.userPasswordRepeat"
					data-vv-name="userPasswordRepeat"
					type="password"
					autocomplete="new-password"
					required
				></md-input>
				<label>{{ $t("common.password.repeat") }}</label> <!-- Must be after input for autofill fix -->
			</md-field>
		</form>
	</SignUpPageBase>
</template>


<script>
import {mapActions, mapGetters} from "vuex";
import SignUpPageBase from "@/views/register/SignUpPageBase";
import TermsAndConditionsDisplay from "@/components/templates/common/TermsAndConditionsDisplay";

export default {
	components: {
		TermsAndConditionsDisplay,
		SignUpPageBase,
	},
	data() {
		return {
			form: {
				userEmail: "",
				userPassword: "",
				userPasswordRepeat: "",
			},
			modelValidations: {
				userPassword: {
					required: true
				},
				userPasswordRepeat: {
					required: true,
					confirmed: "userPassword"
				},
			},
		};
	},
	created() {
		this.$mergeOnlyExistingProps(this.form, this.signUpData, true);
		this.$mergeOnlyExistingProps(this.form, this.signUpCredentials, true);
	},
	computed: {
		...mapGetters({
			signUpData: "local/signUpData",
			signUpSettings: "local/signUpSettings",
			signUpCredentials: "signUpCredentials"
		}),
		shouldBeSkipped() {
			return false;
			// if there is no check for password-skip with invitation code, the password step should not be skipped
			// return !this.signUpSettings.requiresUserPassword;
		},
		strength() {
			let level = 0;
			let difficulty = [/[a-z]/, /[A-Z]/, /[!@#$%^&*()]/, /.{8,}/];

			for (let item of difficulty) {
				if (item.test(this.form.userPassword)) {
					level += 1;
				}
			}
			return level;
		}
	},
	methods: {
		...mapActions({
			setSignUpCredentials: "setSignUpCredentials"
		}),
		beforeNext() {
			return new Promise(resolve => {
				this.setSignUpCredentials({
					userPassword: this.form.userPassword,
					userPasswordRepeat: this.form.userPasswordRepeat
				});

				// Make sure the credentials are removed before writing the form data to the storage
				delete this.form.userPassword;
				delete this.form.userPasswordRepeat;

				resolve();
			});
		}
	}
};
</script>

<style lang="scss" scoped>
	.strength {
		display: flex;

		span {
			width: 50px;
			height: 5px;

			&:nth-child(1) {
				background: red;
			}

			&:nth-child(2) {
				background: yellow;
			}

			&:nth-child(3) {
				background: green;
			}
		}
	}

	.tip_list {
		list-style: none;
		padding: 0;
		margin: 10px 0;

		li:nth-of-type(2) {
			margin: 0;
		}

		i {
			padding-right: 12px;
		}
	}
</style>
